import Vue from 'vue'
import Router from 'vue-router'
import bindApp from '@/components/bindApp'
import HelloWorld from '@/components/HelloWorld'
import wxBindPhone from '@/components/wxBindPhone'
import bindSuccess from '@/components/bindSuccess'

Vue.use(Router)

export default new Router({
   // mode: 'history',
  routes: [
    {
      path: '/bindApp',
      name: 'bindApp',
      component: bindApp
    },
    {
      path: '/wxBind',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/wxBindPhone',
      name: 'wxBindPhone',
      component: wxBindPhone
    },
    {
      path: '/bindSuccess',
      name: 'bindSuccess',
      component: bindSuccess
    }

    // {
    //   path: '/login',
    //   name: 'login',
    //   component: login
    // },
    // {
    //   path: '/register',
    //   name: 'register',
    //   component: register
    // },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js